import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Typography, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import FieldView2 from 'core/components/layout/FieldView2';
import { updateStitchingtaskInfo} from 'components/stitchingtask/StitchingtaskAPI';
import { updateStitchingtaskObj } from 'store/slice/ManufSlice';
import { setStitchingtaskCollectWorkModal } from 'store/slice/ManufSlice';

export default function CollectWorkActionImpl() {
    const dispatch = useDispatch();
    const { stitchingtaskObj } = useSelector((state) => state.manufslice.stitchingtaskDashboard);
    const [receivedQty, setReceivedQty] = useState(stitchingtaskObj.receivedqty|| null);
    const {product2skill2exp2rateList} = useSelector((state) => state.manufslice);
    const {mfproductorderObj} = useSelector((state) => state.manufslice.mfproductorderDashboard);
    const [selectedRateObj, setSelectedRateObj] = useState(null);
    
    useEffect(() => {
        let rateObj = product2skill2exp2rateList.find(obj => obj.productid === mfproductorderObj.productid && obj.workerid === stitchingtaskObj.workerid);
        setSelectedRateObj(rateObj);
    },[]);

    const saveStitchingTask = () => {
            updateStitchingtaskInfo(stitchingtaskObj.id, 
                {   'receivedqty':receivedQty,
                    'earning': (receivedQty * (selectedRateObj ? selectedRateObj.rate : 0))
                }, 
                
                (response) => {
                dispatch(updateStitchingtaskObj(response));
                dispatch(setStitchingtaskCollectWorkModal(false));
                
            }, (error) => {
                console.error("Error updating stitching task:", error);
            });
                     
    }

    return (
        <Grid container direction="column" sx={{ padding: 1, backgroundColor: 'secondary.100' }}>
            <Grid item lg={12} xs={12} sx={{backgroundColor:'white',  borderRadius: 2, }}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ }}>
                    <Grid item lg={6} xs={6}><FieldView2 label={"Product"} value={stitchingtaskObj && stitchingtaskObj.productname} /></Grid>
                    <Grid item lg={6} xs={6}><FieldView2 label={"Allocated Qty"} value={stitchingtaskObj && stitchingtaskObj.assignedqty} /></Grid>
                </Grid>
            </Grid>
            <Grid item lg={12} xs={12} sx={{mt:2,backgroundColor:'white',  borderRadius: 2, padding:1 }}>
                <Grid container direction="column">
                    <Grid item lg={12} xs={12} sx={{}}>
                        <Typography variant="h6" color="primary">Enter Received Quantity</Typography>
                    </Grid>
                    <Grid item lg={12} xs={12} sx={{mt:1}}>
                        <TextField
                            label="Received Quantity"
                            type="number"
                            value={receivedQty}
                            onChange={e => setReceivedQty(e.target.value)}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid container justifyContent="flex-end" lg={12} xs={12} sx={{mt:2}}>
                        <Button variant="contained" color="primary" onClick={()=>saveStitchingTask()} disabled={!receivedQty}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid> 
    
        
    );
}